import { useState, useEffect } from "react";

// ============================================================
// COPIAR archivos en: C:\Users\DELL\rlpharma-lms\public\
//
// public/
//   docs/
//     ecosistema.pdf            ← Ecosistema.pdf
//     manual-sagrilaft.html     ← manual-sagrilaft.html  (del output)
//     ptee.html                 ← ptee.html              (del output)
//   imagenes/
//     infografia.jpeg           ← Infografia_Sagrilaft-PTEE.jpeg
//     mapa-mental.jpeg          ← MapaTEE.jpeg
//
// NOTA: ya NO se necesita mammoth ni .docx en public/
//       los manuales son HTML estáticos listos para iframe
// ============================================================

const DOCUMENTOS = [
  {
    id: 1, tipo: "Infografía", tipoBadgeColor: "#0055a5",
    titulo: "Infografía SAGRILAFT & PTEE",
    subtitulo: "Escudo de Integridad y Cumplimiento Integral",
    descripcion: "Resumen visual de ambos sistemas: SAGRILAFT (prevención financiera) y PTEE (ética empresarial), componentes clave y obligaciones.",
    imagen: "/imagenes/infografia.jpeg", accion: "ver-imagen", icono: "🛡️",
  },
  {
    id: 2, tipo: "Mapa Mental", tipoBadgeColor: "#7f1d1d",
    titulo: "Mapa Mental del Ecosistema",
    subtitulo: "Sistemas de Cumplimiento RLpharma S.A.S.",
    descripcion: "Visión completa del ecosistema de cumplimiento: marco normativo, estructura organizacional, factores de riesgo y operación.",
    imagen: "/imagenes/mapa-mental.jpeg", accion: "ver-imagen", icono: "🧠",
  },
  {
    id: 3, tipo: "Guía Operativa", tipoBadgeColor: "#1e40af",
    titulo: "Ecosistema de Integridad RLpharma",
    subtitulo: "Guía Operativa Integrada — 2025",
    descripcion: "Guía completa con diagramas, casos prácticos, reglas operativas, canal ético y normativa 2025. 15 láminas.",
    imagen: null, accion: "leer-pdf", archivo: "/docs/ecosistema.pdf",
    icono: "🌐", gradiente: "linear-gradient(135deg,#1e40af,#2563eb)", paginas: "15 láminas",
  },
  {
    id: 4, tipo: "Manual Oficial", tipoBadgeColor: "#0055a5",
    titulo: "Manual SAGRILAFT 2025",
    subtitulo: "Manual RLpharma V3 — Salud Segura",
    descripcion: "Manual completo de SAGRILAFT: procedimientos detallados, marcos normativos, matrices de riesgo, políticas y guías operativas.",
    imagen: null, accion: "leer-html", archivo: "/docs/manual-sagrilaft.html",
    icono: "📘", gradiente: "linear-gradient(135deg,#003366,#0055a5)",
  },
  {
    id: 5, tipo: "Manual Oficial", tipoBadgeColor: "#92400e",
    titulo: "Manual PTEE 2025",
    subtitulo: "Transparencia y Ética Empresarial",
    descripcion: "Manual PTEE completo: políticas de regalos, conflictos de interés, canal ético, contratación estatal y régimen sancionatorio.",
    imagen: null, accion: "leer-html", archivo: "/docs/ptee.html",
    icono: "⚖️", gradiente: "linear-gradient(135deg,#92400e,#b45309)",
  },
];

/* ══════════════════════════════════
   MODAL BASE
══════════════════════════════════ */
function Modal({ titulo, subtitulo, icono, onCerrar, extra, children }) {
  useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    const onKey = (e) => { if (e.key === "Escape") onCerrar(); };
    window.addEventListener("keydown", onKey);
    return () => { document.body.style.overflow = prev; window.removeEventListener("keydown", onKey); };
  }, [onCerrar]);

  return (
    <div
      onClick={onCerrar}
      style={{
        position: "fixed", inset: 0, zIndex: 9999,
        background: "rgba(0,0,0,0.88)",
        display: "flex", alignItems: "center", justifyContent: "center", padding: 16,
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          width: "100%", maxWidth: 960,
          height: "92vh",
          display: "flex", flexDirection: "column",
          background: "#0f1929", borderRadius: 14,
          overflow: "hidden",
          boxShadow: "0 24px 64px rgba(0,0,0,0.6)",
        }}
      >
        {/* Cabecera fija */}
        <div style={{
          flexShrink: 0, background: "#003366",
          padding: "12px 20px",
          display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12,
        }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10, minWidth: 0 }}>
            <span style={{ fontSize: 20, flexShrink: 0 }}>{icono}</span>
            <div style={{ minWidth: 0 }}>
              <div style={{ color: "#fff", fontWeight: 700, fontSize: 14, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{titulo}</div>
              <div style={{ color: "rgba(255,255,255,0.5)", fontSize: 11 }}>{subtitulo}</div>
            </div>
          </div>
          <div style={{ display: "flex", gap: 8, flexShrink: 0, alignItems: "center" }}>
            {extra}
            <button onClick={onCerrar} style={{
              background: "rgba(255,255,255,0.1)", border: "1px solid rgba(255,255,255,0.2)",
              borderRadius: 7, color: "#fff", cursor: "pointer",
              fontSize: 12, fontWeight: 600, padding: "7px 14px",
            }}>✕ Cerrar</button>
          </div>
        </div>

        {/* Zona de contenido */}
        <div style={{ flex: 1, overflow: "hidden", position: "relative" }}>
          {children}
        </div>
      </div>
    </div>
  );
}

/* ══════════════════════════════════
   VISOR IMAGEN
══════════════════════════════════ */
function VisorImagen({ doc, onCerrar }) {
  const [err, setErr] = useState(false);
  return (
    <Modal titulo={doc.titulo} subtitulo={doc.subtitulo} icono={doc.icono} onCerrar={onCerrar}>
      <div style={{ width: "100%", height: "100%", background: "#0a0f1a", display: "flex", alignItems: "center", justifyContent: "center", padding: 16, overflow: "auto" }}>
        {!err
          ? <img src={doc.imagen} alt={doc.titulo} onError={() => setErr(true)}
              style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain", borderRadius: 8 }} />
          : <div style={{ textAlign: "center", color: "#94a3b8", padding: 40 }}>
              <div style={{ fontSize: 48 }}>{doc.icono}</div>
              <p style={{ marginTop: 12, fontSize: 13 }}>
                Imagen no encontrada.<br/>
                Copia el archivo en: <code style={{ background: "#1e293b", padding: "2px 8px", borderRadius: 4 }}>public{doc.imagen}</code>
              </p>
            </div>
        }
      </div>
    </Modal>
  );
}

/* ══════════════════════════════════
   VISOR PDF — objeto embebido
   FIX: pointer-events:none en overlay evita que capture clicks
══════════════════════════════════ */
function VisorPDF({ doc, onCerrar }) {
  const [cargando, setCargando] = useState(true);

  return (
    <Modal
      titulo={doc.titulo} subtitulo={doc.subtitulo} icono={doc.icono} onCerrar={onCerrar}
      extra={
        <a href={doc.archivo} target="_blank" rel="noreferrer"
          onClick={(e) => e.stopPropagation()}
          style={{
            background: "rgba(255,255,255,0.1)", border: "1px solid rgba(255,255,255,0.2)",
            borderRadius: 7, color: "#fff", textDecoration: "none",
            fontSize: 12, fontWeight: 600, padding: "7px 14px",
          }}>↗ Nueva pestaña</a>
      }
    >
      {/* Contenedor: height 100% fijo para el PDF */}
      <div style={{ width: "100%", height: "100%", position: "relative", background: "#525659" }}>

        {/* Spinner de carga */}
        {cargando && (
          <div style={{
            position: "absolute", inset: 0, zIndex: 10,
            background: "#525659", display: "flex",
            flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 16,
            pointerEvents: "none",   // ← NO intercepta clicks del usuario
          }}>
            <div style={{ width: 40, height: 40, borderRadius: "50%", border: "3px solid rgba(255,255,255,0.2)", borderTopColor: "#fff", animation: "spin 0.8s linear infinite" }}/>
            <span style={{ color: "#fff", fontSize: 13 }}>Cargando PDF…</span>
            <span style={{ color: "rgba(255,255,255,0.5)", fontSize: 11 }}>Ecosistema de Integridad · 15 MB</span>
          </div>
        )}

        {/*
          FIX CRÍTICO: usamos <embed> en lugar de <object> o <iframe>.
          <embed> no redirige la app cuando el usuario hace click dentro.
          stopPropagation en el wrapper evita que el click en el PDF
          llegue al overlay oscuro y cierre el modal.
        */}
        <div
          style={{ width: "100%", height: "100%" }}
          onClick={(e) => e.stopPropagation()}
        >
          <embed
            src={doc.archivo}
            type="application/pdf"
            style={{ width: "100%", height: "100%", border: "none", display: "block" }}
            onLoad={() => setCargando(false)}
          />
        </div>
      </div>
    </Modal>
  );
}

/* ══════════════════════════════════
   VISOR HTML (manuales estáticos)
   FIX: usa iframe con scrolling, sin mammoth
══════════════════════════════════ */
function VisorHTML({ doc, onCerrar }) {
  const [cargando, setCargando] = useState(true);
  const [err, setErr] = useState(false);

  return (
    <Modal titulo={doc.titulo} subtitulo={doc.subtitulo} icono={doc.icono} onCerrar={onCerrar}
      extra={
        <a href={doc.archivo} target="_blank" rel="noreferrer"
          onClick={(e) => e.stopPropagation()}
          style={{
            background: "rgba(255,255,255,0.1)", border: "1px solid rgba(255,255,255,0.2)",
            borderRadius: 7, color: "#fff", textDecoration: "none",
            fontSize: 12, fontWeight: 600, padding: "7px 14px",
          }}>↗ Nueva pestaña</a>
      }
    >
      <div style={{ width: "100%", height: "100%", position: "relative" }}
           onClick={(e) => e.stopPropagation()}>

        {cargando && !err && (
          <div style={{
            position: "absolute", inset: 0, zIndex: 10,
            background: "#f8fafc", display: "flex",
            flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 16,
            pointerEvents: "none",
          }}>
            <div style={{ width: 40, height: 40, borderRadius: "50%", border: "3px solid #e2e8f0", borderTopColor: "#003366", animation: "spin 0.8s linear infinite" }}/>
            <span style={{ fontSize: 13, color: "#64748b" }}>Cargando documento…</span>
          </div>
        )}

        {err && (
          <div style={{ padding: 48, textAlign: "center" }}>
            <span style={{ fontSize: 44 }}>⚠️</span>
            <p style={{ fontSize: 14, fontWeight: 700, color: "#92400e", margin: "16px 0 8px" }}>
              Archivo no encontrado
            </p>
            <div style={{ background: "#fef3c7", border: "1px solid #f59e0b", borderRadius: 8, padding: "14px 20px", display: "inline-block", textAlign: "left", marginTop: 8 }}>
              <p style={{ fontSize: 13, color: "#92400e", margin: "0 0 6px", fontWeight: 700 }}>Copia el archivo en:</p>
              <code style={{ fontSize: 12, background: "#fff8e1", padding: "4px 10px", borderRadius: 4 }}>
                public{doc.archivo}
              </code>
            </div>
          </div>
        )}

        {/* iframe con scroll completo — muestra el HTML estático sin limite de altura */}
        <iframe
          src={doc.archivo}
          title={doc.titulo}
          style={{
            width: "100%",
            height: "100%",
            border: "none",
            display: "block",
            background: "#f8fafc",
          }}
          onLoad={(e) => {
            setCargando(false);
            // Detectar si el iframe cargó la app en lugar del archivo
            try {
              const body = e.target.contentDocument?.body?.innerText || "";
              if (body.length < 50) setErr(true);
            } catch (_) {
              // cross-origin: no podemos leer, asumir que cargó bien
            }
          }}
          onError={() => { setCargando(false); setErr(true); }}
        />
      </div>
    </Modal>
  );
}

/* ══════════════════════════════════
   TARJETA
══════════════════════════════════ */
function TarjetaDocumento({ doc, onAbrir }) {
  const [imgErr, setImgErr] = useState(false);
  const [hover, setHover] = useState(false);

  const LABELS = {
    "ver-imagen": "🔍 Ver infografía",
    "leer-pdf":   "📄 Ver presentación",
    "leer-html":  "📖 Leer manual completo",
  };
  const COLORES = {
    "ver-imagen": "#1e293b",
    "leer-pdf":   "linear-gradient(135deg,#0f766e,#0d9488)",
    "leer-html":  "linear-gradient(135deg,#003366,#0055a5)",
  };

  return (
    <div
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        background: "#fff", borderRadius: 14,
        border: "1px solid #e2e8f0", overflow: "hidden",
        display: "flex", flexDirection: "column",
        boxShadow: hover ? "0 8px 28px rgba(0,51,102,0.14)" : "0 1px 4px rgba(0,0,0,0.06)",
        transform: hover ? "translateY(-3px)" : "translateY(0)",
        transition: "all 0.22s cubic-bezier(.4,0,.2,1)",
        cursor: "pointer",
      }}
    >
      {/* Zona visual */}
      <div onClick={() => onAbrir(doc)}
        style={{ position: "relative", height: 190, background: "#f1f5f9", overflow: "hidden", flexShrink: 0 }}>
        <span style={{
          position: "absolute", top: 10, left: 10, zIndex: 2,
          background: doc.tipoBadgeColor, color: "#fff",
          fontSize: 11, fontWeight: 700, padding: "3px 11px", borderRadius: 20,
        }}>{doc.tipo}</span>

        {doc.imagen && !imgErr ? (
          <>
            <img src={doc.imagen} alt={doc.titulo}
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
              onError={() => setImgErr(true)} />
            <div style={{
              position: "absolute", inset: 0, background: "rgba(0,0,0,0.42)",
              display: "flex", alignItems: "flex-end", justifyContent: "flex-end", padding: 12,
              opacity: hover ? 1 : 0, transition: "opacity 0.2s",
            }}>
              <span style={{ background: "rgba(255,255,255,0.95)", borderRadius: 8, padding: "6px 14px", fontSize: 12, fontWeight: 700, color: "#1e293b" }}>
                {LABELS[doc.accion]}
              </span>
            </div>
          </>
        ) : (
          <div style={{
            width: "100%", height: "100%", display: "flex",
            flexDirection: "column", alignItems: "center", justifyContent: "center",
            background: doc.gradiente || "linear-gradient(135deg,#1e3a5f,#2d6a9f)", color: "#fff",
          }}>
            <span style={{ fontSize: 50, marginBottom: 8 }}>{doc.icono}</span>
            <span style={{ fontSize: 12, fontWeight: 600, opacity: 0.85, textAlign: "center", padding: "0 14px", lineHeight: 1.4 }}>{doc.subtitulo}</span>
            {doc.paginas && <span style={{ fontSize: 11, opacity: 0.6, marginTop: 6 }}>{doc.paginas}</span>}
          </div>
        )}
      </div>

      {/* Contenido */}
      <div style={{ padding: "15px 17px 17px", flex: 1, display: "flex", flexDirection: "column" }}>
        <p style={{ fontSize: 11, color: "#6366f1", fontWeight: 600, margin: "0 0 4px" }}>
          {doc.icono} {doc.subtitulo}
        </p>
        <h3 style={{ fontSize: 15, fontWeight: 700, color: "#1e293b", margin: "0 0 8px", lineHeight: 1.3 }}>
          {doc.titulo}
        </h3>
        <p style={{ fontSize: 13, color: "#64748b", margin: "0 0 14px", lineHeight: 1.55, flex: 1 }}>
          {doc.descripcion}
        </p>
        <button onClick={() => onAbrir(doc)} style={{
          background: COLORES[doc.accion], color: "#fff", border: "none",
          borderRadius: 8, padding: "10px 16px", fontSize: 13,
          fontWeight: 600, cursor: "pointer", width: "100%", transition: "opacity 0.18s",
        }}
          onMouseEnter={(e) => (e.currentTarget.style.opacity = "0.85")}
          onMouseLeave={(e) => (e.currentTarget.style.opacity = "1")}
        >{LABELS[doc.accion]}</button>
      </div>
    </div>
  );
}

/* ══════════════════════════════════
   COMPONENTE PRINCIPAL
══════════════════════════════════ */
export default function DocumentacionTab() {
  const [docActivo, setDocActivo] = useState(null);
  const [filtro, setFiltro] = useState("Todos");

  const tipos = ["Todos", "Infografía", "Mapa Mental", "Guía Operativa", "Manual Oficial"];
  const filtrados = filtro === "Todos" ? DOCUMENTOS : DOCUMENTOS.filter(d => d.tipo === filtro);

  const renderVisor = () => {
    if (!docActivo) return null;
    if (docActivo.accion === "ver-imagen") return <VisorImagen doc={docActivo} onCerrar={() => setDocActivo(null)} />;
    if (docActivo.accion === "leer-pdf")   return <VisorPDF   doc={docActivo} onCerrar={() => setDocActivo(null)} />;
    if (docActivo.accion === "leer-html")  return <VisorHTML  doc={docActivo} onCerrar={() => setDocActivo(null)} />;
    return null;
  };

  return (
    <div style={{ padding: "28px 4px", maxWidth: 1100, margin: "0 auto" }}>

      <h2 className="lms-title" style={{ fontSize: 22, fontWeight: 700, color: "#003366", margin: "0 0 5px" }}>
        📁 Documentación y Material de Referencia
      </h2>
      <p style={{ color: "rgba(0,51,102,0.5)", margin: "0 0 24px", fontSize: 13 }}>
        Infografías, mapas de proceso y manuales oficiales de SAGRILAFT &amp; PTEE.
      </p>

      {/* Filtros */}
      <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 24 }}>
        {tipos.map(t => (
          <button key={t} onClick={() => setFiltro(t)} style={{
            padding: "5px 16px", borderRadius: 20, border: "1px solid",
            borderColor: filtro === t ? "#0055a5" : "#e2e8f0",
            background: filtro === t ? "#0055a5" : "#fff",
            color: filtro === t ? "#fff" : "rgba(0,51,102,0.55)",
            fontSize: 12, fontWeight: filtro === t ? 700 : 400,
            cursor: "pointer", transition: "all 0.15s",
          }}>{t}</button>
        ))}
      </div>

      {/* Grid */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(255px,1fr))", gap: 20 }}>
        {filtrados.map(doc => (
          <TarjetaDocumento key={doc.id} doc={doc} onAbrir={setDocActivo} />
        ))}
      </div>

      {renderVisor()}
    </div>
  );
}
